// EN
export const hotelRatesManager = {
  perNight: "/ notte",
  roomFallback: "Camera #{id}",

  header: {
    eyebrow: "Tariffe principali",
    title: "Tariffe hotel",
    subtitle:
      "Crea tariffe base e applicale a una o più camere. Le tariffe derivate si sincronizzano con il channel manager.",
    newMain: "Nuova tariffa principale",
  },
  states: {
    loading: "Caricamento tariffe…",
    emptyTitle: "Ancora nessuna tariffa",
    emptySubtitle:
      "Crea la prima tariffa principale per iniziare a gestire i prezzi e a sincronizzare con il channel manager.",
    createFirst: "Crea la prima tariffa",
  },
  card: {
    mainBadge: "Principale",
    occupancy: "Occ. {count}",
    minStay: "Min. {count} notte | Min. {count} notti",
    editRate: "Modifica tariffa",
    deleteRate: "Elimina tariffa",
    rooms: "Camere",
    syncedTooltip: "Sincronizzata con il channel manager",
    removeSyncedTooltip: "Rimuovi (attenzione: channel manager)",
    removeRoomTooltip: "Rimuovi da questa camera",
    add: "Aggiungi",
    selectRoom: "Seleziona camera",
    derivedBadge: "Derivata",
    derivedFrom: "da {name}",
    sameNameHint: "C’è un’altra «{name}» con un prezzo o condizioni diverse. Ogni scheda si modifica separatamente.",
    editDerived: "Modifica derivata",
    deleteDerived: "Elimina derivata",
  },
  derived: {
    toggle: "Tariffe derivate",
    empty:
      "Ancora nessuna tariffa derivata. Creane una per Booking.com, Airbnb o OTA specifiche.",
    newDerived: "Nuova tariffa derivata",
  },
  common: {
    allRooms: "tutte le camere",
    cancel: "Annulla",
    saving: "Salvataggio…",
    creating: "Creazione…",
    saveChanges: "Salva modifiche",
    removeAll: "Rimuovi tutte",
  },
  mainModal: {
    editTitle: "Modifica tariffa principale",
    newTitle: "Nuova tariffa principale",
    nameLabel: "Nome",
    namePlaceholder: "Es. Tariffa standard, Weekend…",
    priceLabel: "Prezzo per notte",
    occupancyLabel: "Occupazione",
    minStayLabel: "Soggiorno minimo (notti)",
    maxStayLabel: "Soggiorno massimo (notti)",
    validityLabel: "Validità",
    permanent: "Permanente",
    dateRange: "Intervallo di date",
    from: "Da",
    to: "A",
    descriptionLabel: "Descrizione (opzionale)",
    descriptionPlaceholder: "Note interne su questa tariffa…",
    searchPlaceholder: "Cerca camera…",
    selectAllShort: "Tutte",
    noResults: 'Nessun risultato per "{query}"',
    noRoomsAvailable: "Nessuna camera disponibile",
    editInfo: "Le modifiche si applicheranno a {rooms} di questa scheda.",
    createRate: "Crea tariffa",
  },
  derivedModal: {
    editTitle: "Modifica tariffa derivata",
    newTitle: "Nuova tariffa derivata",
    subtitle: "Derivata da {name} · {price}",
    nameLabel: "Nome tariffa derivata",
    namePlaceholder: "Es. Booking.com, Airbnb, Senza colazione…",
    nameHint: "Questo nome identifica la tariffa nel channel manager.",
    adjustTypeLabel: "Tipo di adeguamento",
    percentage: "Percentuale",
    fixedAmount: "Importo fisso",
    adjustValueLabel: "Valore dell’adeguamento",
    adjustValueHint: "(negativo = sconto)",
    resultPriceLabel: "Prezzo risultante",
    baseLabel: "Base",
    applyToRooms: "Applica alle camere",
    onlyMainRooms: "Vengono mostrate solo le camere che hanno la tariffa principale.",
    noRoomsWithMain: "La tariffa principale non è ancora applicata a nessuna camera.",
    selectAll: "Seleziona tutte",
    editInfo:
      "La modifica aggiornerà l’adeguamento su {rooms} che hanno questa tariffa derivata.",
    createDerived: "Crea derivata",
  },
  removeModal: {
    title: "Rimuovi dalla camera",
    syncWarnTitle: "Questa tariffa è sincronizzata con il channel manager",
    syncWarnBody:
      "La rimozione potrebbe {break} delle tariffe in Channex per questa camera. Controlla il channel manager prima di continuare.",
    syncWarnBreak: "interrompere la sincronizzazione",
    confirmText: "Questa azione rimuoverà la tariffa {rate} dalla camera {room}.",
    roomLabel: "Camera",
    rateLabel: "Tariffa",
    statusLabel: "Stato",
    syncedWithChannex: "Sincronizzata con Channex",
    removing: "Rimozione…",
    removeAnyway: "Ho capito, rimuovi comunque",
    confirm: "Rimuovi dalla camera",
  },
  deleteModal: {
    title: "Elimina tariffa",
    warnTitle: "Questa azione non può essere annullata",
    warnBody: "La tariffa {rate} verrà rimossa da {rooms}.",
    roomsCount: "{count} camera | {count} camere",
    syncedWarn:
      "Alcune camere sono sincronizzate con Channex. Questo potrebbe influire sulla sincronizzazione delle tariffe.",
    confirmLabel: "Digita {name} per confermare",
    deleting: "Eliminazione…",
    confirm: "Elimina definitivamente",
  },
  toasts: {
    loadError: "Errore nel caricamento delle tariffe dell’hotel",
    mainCreated: "Tariffa creata in {count} camera | Tariffa creata in {count} camere",
    createdPartial: "{ok} create, {fail} non riuscite",
    mainCreateFailAll: "Impossibile creare la tariffa in qualsiasi camera",
    mainUpdated: "Tariffa aggiornata",
    updatedPartial: "{ok} aggiornate, {fail} non riuscite",
    mainUpdateFail: "Impossibile aggiornare la tariffa",
    derivedCreated:
      "Tariffa derivata creata in {count} camera | Tariffa derivata creata in {count} camere",
    derivedCreateFail: "Impossibile creare la tariffa derivata",
    derivedUpdated: "Tariffa derivata aggiornata",
    derivedUpdateFail: "Impossibile aggiornare la tariffa derivata",
    roomAddedMain: "Tariffa aggiunta a {room}",
    addRateError: "Errore nell’aggiunta della tariffa",
    noMainRate: "Questa camera non ha la tariffa principale. Aggiungila prima.",
    roomAddedDerived: "Tariffa derivata aggiunta a {room}",
    addDerivedError: "Errore nell’aggiunta della tariffa derivata",
    rateRemoved: "Tariffa rimossa da {room}",
    removeError: "Errore nella rimozione della tariffa",
    rateDeleted: "Tariffa eliminata",
    deletedPartial: "{ok} eliminate, {fail} non riuscite",
    deleteError: "Errore nell’eliminazione",
  },
  errors: {
    invalidRange: "Seleziona un intervallo di date valido",
    startAfterEnd: "La data di inizio non può essere successiva alla data di fine",
    minStayRange: "Soggiorno minimo: {minStay} notti, ma l’intervallo ne ha {nights}",
  },
};
